<div class="main-div" fxLayout="column">

    <div class="width-div" fxLayoutGap="15px">


        <div class="higlights-div" fxLayout="row" fxLayoutGap="15px" fxLayout.lt-md="column">

            <div class="first-section" fxLayout="column" fxFlex="39%" fxLayoutGap="15px">

                <div class="img1" *ngFor="let higlight of seq1">
                    <a href="{{higlight.imageUrl}}"
                    appTrackClick 
                    [buttonProps]="{
                    title: 'home_page_'+higlight.imageUrl+'_section',
                    feature_context: 'HOME'
                    }"
                    >
                        <img src="{{higlight.image}}" alt="" fxFlex="100%">
                    </a>
                </div>

                <div class="img2" *ngFor="let higlight of seq4">
                    <a href="{{higlight.imageUrl}}"
                    appTrackClick 
                    [buttonProps]="{
                    title: 'home_page_'+higlight.imageUrl+'_section',
                    feature_context: 'HOME'
                    }"
                    >
                        <img src="{{higlight.image}}" alt="" fxFlex="100%">
                    </a>
                </div>

            </div>

            <div class="second-section" fxLayout="column" fxFlex="60%">

                <div class="img-div" fxLayout="row" fxLayoutGap="15px" fxFlex="100%">

                    <div class="sub-section1" *ngFor="let higlight of seq2" fxFlex="50%">
                        <a href="{{higlight.imageUrl}}"
                        appTrackClick 
                        [buttonProps]="{
                        title: 'home_page_'+higlight.imageUrl+'_section',
                        feature_context: 'HOME'
                        }"
                        >
                            <img src="{{higlight.image}}" alt="" fxFlex="100%">
                        </a>
                    </div>

                    <div class="sub-section1" *ngFor="let higlight of seq3" fxFlex="50%">
                        <a href="{{higlight.imageUrl}}"
                        appTrackClick 
                        [buttonProps]="{
                        title: 'home_page_'+higlight.imageUrl+'_section',
                        feature_context: 'HOME'
                        }"
                        >
                            <img src="{{higlight.image}}" alt="" fxFlex="100%">
                        </a>
                    </div>

                </div>

                <div class="meet-creatics" fxLayout="row wrap" fxFlex="100%"  fxLayoutGap.lt-md="15px"
                   style="gap: 5px;" fxLayout.lt-md="column">

                    <div class="heading-div" fxLayout="row" fxFlex="100%" fxLayoutGap="15px" fxLayout.lt-md="column">

                        <div fxFlex="50%" class="heading">
                            MEET THESE CREATICS
                        </div>

                        <div class="search" fxFlex="50%" fxLayout="row">
                            <input type="text" placeholder="Search Community" [(ngModel)]="searchQuery"
                                (input)="search()" id="text" (ngModelChange)="onSearchQueryChange($event)">
                            <div class="ulDiv" (change)="search()" *ngIf="data == true">
                                <ul fxLayout="column" fxLayoutGap="10px">
                                    <li *ngFor="let user of searchResults">
                                        <div class="li-div" fxLayout="row" fxLayoutGap="5px">
                                            <a href="userProfiles/{{user.id}}?home=false"
                                             appTrackClick 
                                            [buttonProps]="{
                                            title: 'home_page_meet_these_creatics_profile_search_clicked',
                                            customeId:user.value+'_'+user.title,                                            
                                            feature_context: 'HOME'                  
                                            }"
                                            >
                                                <img *ngIf="user.imageURL !== null" src="{{user.imageURL}}">
                                                <img *ngIf="user.imageURL === null" src="assets/images/user-icon.png"
                                                    alt="">
                                                <span class="user-details">{{user.value}} <span>•</span>
                                                    {{user.title}}</span>
                                            </a>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <i *ngIf="searchItem" class="fa fa-search"></i>
                            <i (click)="clear()" *ngIf="close" class="fa fa-times"></i>
                        </div>

                    </div>

                    <div class="user-profile" fxFlex="100%" fxLayout="row" fxLayout.lt-md="column">

                        <div *ngFor="let item of userData" fxFlex="33%">
                            <a href="{{item.url}}?home=false"
                            appTrackClick 
                            [buttonProps]="{
                            title: 'home_page_meet_these_creatics_profile_clicked',
                            customeId:item.name+'_'+item.rank,
                            feature_context: 'HOME'                  
                            }"
                            >
                                <div class="user-data" fxLayout="column" fxLayoutGap="15px">

                                    <img src="{{item.image}}" alt="">

                                    <div fxLayout="column" class="details">
                                        <span class="name">
                                            {{item.name}}
                                        </span>
                                        <span class="rank">
                                            {{item.rank}}
                                        </span>
                                    </div>

                                </div>
                            </a>
                        </div>

                    </div>

                </div>

            </div>

        </div>

        <div class="featured-contest-div">
            <div class="featured-div">
                <span>FEATURED CONTESTS</span>
            </div>

            <div>

                <owl-carousel-o [options]="customOptions">

                    <ng-container *ngFor="let slide of carouselContent">
                        <ng-template carouselSlide [id]="slide.contestId">
                            <a href="{{slide.url}}"
                             appTrackClick 
                            [buttonProps]="{
                            title: 'home_page_featured_contest_'+slide.contestName+'_button',
                            feature_context: 'HOME'
                             }"
                            >
                                <img [src]="slide.contestImageURL" [alt]="" [title]="">
                                <div class="names">
                                    <span>{{slide.contestName}}</span>
                                    <p *ngIf="!slide.contestActive">Coming Soon</p>
                                </div>
                            </a>
                        </ng-template>
                    </ng-container>

                </owl-carousel-o>


            </div>

        </div>

        <div class="currency-upvote-div">
            <div class="featured-div" style="margin-top: 0 !important;">
                <span>MY PRIZES + PERKS</span>
            </div>

            <div class="currency-upvote" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="25px">

                <div class="currency-div" fxLayout="column" fxLayoutGap="10px"
                    appTrackClick 
                    [buttonProps]="{
                    title: 'home_page_creatics_currency_button',
                    feature_context: 'HOME'
                    }"
                >
                    <div class="imgs">
                        <img src="/assets/images/profile_rewards_icons_2-14-u555613-fr.png" alt="">
                    </div>
                    <p>CREATICS CURRENCY: {{userCreaticsCurrency}}</p>
                </div>

                <div class="upvote-div" fxLayout="column" fxLayoutGap="10px"
                    appTrackClick 
                    [buttonProps]="{
                    title: 'home_page_jewels_balance_button',
                    feature_context: 'HOME'
                    }"
                >
                    <div class="imgs">
                        <img src="/assets/images/upvote_home.png" alt="">
                    </div>
                    <p>JEWELS BALANCE: {{userUpvoteBalance}}</p>
                </div>

            </div>

        </div>


        <div class="button-div">
            <a href="/meet-creatics"
            appTrackClick 
            [buttonProps]="{
            title: 'home_page_connect_with_more_creatics_button',
            feature_context: 'HOME'
            }"
            >
                <button>
                    CONNECT WITH MORE CREATICS
                </button>
            </a>
        </div>

    </div>

    <ng-template #dialogTemplate let-dialogRef="dialogRef" let-data>
        <div class="custom-dialog-container">
            <h1 mat-dialog-title>{{ data.title }}</h1>
            <hr>
            <p [innerHTML]="data.description"></p>
            <p *ngIf="data.link">
                <a href="{{ data.link }}">Click here to know more!</a>
            </p>
            <hr>
            <button mat-button class="custom-button" (click)="dialogRef.close('Ok')">OK</button>
        </div>
    </ng-template>

</div>